import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import globalMessages from 'translations/messages/global-messages';

const ExcelFile = ({ title = '', intl, color = '#848F9D', ...props }) => {
  return (
    <svg height="24" viewBox="0 0 15 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || intl.formatMessage(globalMessages.export_as_excel)}</title>
      <path
        d="M2.11678 25.256L0.356781 22.664H1.83678L2.83678 24.232L3.79678 22.664H5.13278L3.48478 25.176L5.40478 28H3.91678L2.76478 26.208L1.64478 28H0.316781L2.11678 25.256ZM5.94578 22.664H7.15378V26.928H9.70578V28H5.94578V22.664ZM10.8927 26.408C10.962 26.4827 11.042 26.56 11.1327 26.64C11.2287 26.7147 11.3327 26.784 11.4447 26.848C11.562 26.912 11.6873 26.9653 11.8207 27.008C11.9593 27.0453 12.106 27.064 12.2607 27.064C12.3513 27.064 12.442 27.0507 12.5327 27.024C12.6233 26.9973 12.706 26.96 12.7807 26.912C12.8553 26.8587 12.914 26.7973 12.9567 26.728C13.0047 26.6533 13.0287 26.5707 13.0287 26.48C13.0287 26.2827 12.9327 26.1307 12.7407 26.024C12.5487 25.912 12.2447 25.8027 11.8287 25.696C11.626 25.648 11.4367 25.5787 11.2607 25.488C11.09 25.3973 10.9407 25.288 10.8127 25.16C10.69 25.032 10.594 24.8853 10.5247 24.72C10.4553 24.5547 10.4207 24.3707 10.4207 24.168C10.4207 23.944 10.4607 23.7333 10.5407 23.536C10.6207 23.3387 10.7407 23.1653 10.9007 23.016C11.066 22.8613 11.2687 22.7413 11.5087 22.656C11.754 22.5653 12.042 22.52 12.3727 22.52C12.6447 22.52 12.8847 22.5493 13.0927 22.608C13.3007 22.6613 13.4767 22.728 13.6207 22.808C13.77 22.8827 13.89 22.9627 13.9807 23.048C14.0767 23.128 14.1487 23.192 14.1967 23.24L13.5007 24.008C13.442 23.96 13.3727 23.9093 13.2927 23.856C13.218 23.7973 13.1327 23.744 13.0367 23.696C12.9407 23.648 12.834 23.608 12.7167 23.576C12.6047 23.544 12.4847 23.528 12.3567 23.528C12.2713 23.528 12.186 23.5413 12.1007 23.568C12.0207 23.5947 11.946 23.632 11.8767 23.68C11.8127 23.7227 11.7593 23.776 11.7167 23.84C11.6793 23.8987 11.6607 23.9627 11.6607 24.032C11.6607 24.2133 11.7567 24.36 11.9487 24.472C12.1407 24.584 12.4047 24.6773 12.7407 24.752C12.938 24.8 13.13 24.8667 13.3167 24.952C13.5087 25.032 13.6793 25.1387 13.8287 25.272C13.978 25.4053 14.098 25.5707 14.1887 25.768C14.2793 25.96 14.3247 26.1947 14.3247 26.472C14.3247 26.712 14.2713 26.9333 14.1647 27.136C14.058 27.3387 13.9113 27.5147 13.7247 27.664C13.5433 27.8133 13.3273 27.928 13.0767 28.008C12.8313 28.0933 12.5647 28.136 12.2767 28.136C12.01 28.136 11.7673 28.1093 11.5487 28.056C11.33 28.008 11.1327 27.944 10.9567 27.864C10.7807 27.7787 10.6207 27.6827 10.4767 27.576C10.338 27.4693 10.218 27.36 10.1167 27.248L10.8927 26.408Z"
        fill={color}
      />

      <path
        d="M8.2 1H2.6C2.17565 1 1.76869 1.16857 1.46863 1.46863C1.16857 1.76869 1 2.17565 1 2.6V15.4C1 15.8243 1.16857 16.2313 1.46863 16.5314C1.76869 16.8314 2.17565 17 2.6 17H12.2C12.6243 17 13.0313 16.8314 13.3314 16.5314C13.6314 16.2313 13.8 15.8243 13.8 15.4V6.6L8.2 1Z"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M8.20001 1V6.6H13.8"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ExcelFile.propTypes = {
  title: PropTypes.string,
  intl: PropTypes.object.isRequired,
  color: PropTypes.string,
};

export default injectIntl(ExcelFile);
